import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";


import './ProjectDetail.css'
const ProjectDetail = (props) => {
    const { id, name, description, imgURL, tech, liveLink, sourceCode } = props.project;
    console.log(props);
    return (
        <div class="col-xs-12 col-sm-6 col-md-3 col-lg-4 py-3">
                <div class="card-flyer h-100">
                    <div class="text-box">
                        <div class="image-box">
                            <img src={imgURL} alt="" />
                        </div>
                        <div class="text-container">
                            <p> <b>{name}</b> </p>
                            <p>{description}</p>
                            <div className="d-flex align-items-center justify-content-between ">
                                <ul className="list-inline d-flex flex-row flex-wrap gap-2">
                                    {
                                        tech.map(
                                            item => (
                                                <li className="list-inline-item box-style rounded ps-2 pe-2">{item}</li>
                                            )
                                        )
                                    }
                                </ul>
                            </div>
                            <div className="mt-2">
                                <a className="text-decoration-none fs-3" target="_blank" href={liveLink}><FaExternalLinkAlt /></a>
                                <a className="text-decoration-none fs-3" target="_blank" href={sourceCode}> <FaGithub /> </a>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default ProjectDetail;

